import styled from 'styled-components';
import { IconInfo } from '../../common/components/icons/IconInfo';
import { Close } from '../../common/components/icons/outlined/Close';
import { ThemeColours } from '../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontSize,
  FontWeight,
  FONT_STACK,
  LineHeight,
  ZIndex,
} from '../../common/styles/constants';
import { propSwitch } from '../../common/util/propSwitch';

export const Slide = styled.div<{ isVisible: boolean }>`
  ${FONT_STACK}
  background-color: ${ThemeColours.primary50};
  cursor: pointer;
  display: flex;
  font-size: ${propSwitch('isVisible', FontSize.EXTRA_SMALL, '0')};
  font-weight: ${FontWeight.SEMI_BOLD};
  height: ${propSwitch('isVisible', 'auto', '0')};
  line-height: ${LineHeight.SMALL};
  margin-bottom: ${propSwitch('isVisible', '8px', '0')};
  padding: ${propSwitch('isVisible', '8px 2px 8px 16px', '0')};
  transform: ${propSwitch('isVisible', 'translateX(0px)', 'translateX(500px)')};
  transition: all 0.3s ease-in-out;

  ${Breakpoint.SMALL} {
    border-radius: 6px;
    bottom: 30px;
    font-size: ${propSwitch('isVisible', FontSize.SMALL, '0')};
    height: auto;
    left: auto;
    margin-bottom: 0;
    max-width: 386px;
    padding: auto;
    padding-right: 8px;
    position: fixed;
    right: 30px;
    z-index: ${ZIndex.OVERLAY};
  }
`;

export const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 40px;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  margin-right: 8px;
  transition: all 0.3s ease-in-out;

  ${Breakpoint.SMALL} {
    flex-basis: 44px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 0;
  }
`;

export const CrossWrapper = styled.div`
  display: flex;
`;

export const CrossIcon = styled(Close)<{ isVisible: boolean }>`
  height: ${propSwitch('isVisible', '29px', '0')};
  transition: all 0.3s ease-in-out;
  width: ${propSwitch('isVisible', '29px', '0')};

  ${Breakpoint.SMALL} {
    height: ${propSwitch('isVisible', '24px', '0')};
    width: ${propSwitch('isVisible', '24px', '0')};
  }
`;

export const PHILink = styled.a`
  color: ${ThemeColours.mono900};
  cursor: pointer;
  padding-right: 3px;
  text-decoration: none;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-basis: 24px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 16px;
`;

export const InfoIcon = styled(IconInfo)`
  height: 100%;
  width: 100%;
`;
